import { render } from "./Dashboard-EIS-Pejabat-Perhutanan.vue?vue&type=template&id=1a5c19d2"
import script from "./Dashboard-EIS-Pejabat-Perhutanan.vue?vue&type=script&lang=js"
export * from "./Dashboard-EIS-Pejabat-Perhutanan.vue?vue&type=script&lang=js"

import "./Dashboard-EIS-Pejabat-Perhutanan.vue?vue&type=style&index=0&id=1a5c19d2&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__